"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _RuleGroup = _interopRequireDefault(require("./RuleGroup.style"));
var _misc = require("../misc");
var _icon = _interopRequireDefault(require("../icon"));
var _excluded = ["id", "groupOperator", "labels", "children", "isSelected", "className", "isDuplicateDisabled", "isMenuHidden", "pathKeys", "onDuplicate", "onDelete", "disabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RuleGroup = function RuleGroup(_ref) {
  var id = _ref.id,
    groupOperator = _ref.groupOperator,
    labels = _ref.labels,
    children = _ref.children,
    isSelected = _ref.isSelected,
    className = _ref.className,
    isDuplicateDisabled = _ref.isDuplicateDisabled,
    isMenuHidden = _ref.isMenuHidden,
    pathKeys = _ref.pathKeys,
    onDuplicate = _ref.onDuplicate,
    onDelete = _ref.onDelete,
    disabled = _ref.disabled,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var menuItems = [];
  if (!isDuplicateDisabled) {
    menuItems.push({
      name: labels.ELIGIBILITY_DUPLICATE_GROUP,
      icon: 'ion-ios-copy',
      onClick: function onClick() {
        onDuplicate(pathKeys);
      }
    });
  }
  menuItems.push({
    name: labels.ELIGIBILITY_DELETE_GROUP,
    icon: 'ion-trash-b',
    onClick: function onClick() {
      onDelete('group', pathKeys);
    }
  });
  var operatorLabel;
  switch ((0, _utils.toUpper)(groupOperator)) {
    case 'AND':
      operatorLabel = labels.ELIGIBILITY_AND_OPERATOR;
      break;
    case 'OR':
      operatorLabel = labels.ELIGIBILITY_OR_OPERATOR;
      break;
    case 'IF':
      operatorLabel = labels.ELIGIBILITY_IF_KEYWORD;
      break;
    default:
      operatorLabel = groupOperator;
  }
  return /*#__PURE__*/_react["default"].createElement(_RuleGroup["default"], _extends({
    id: id,
    className: "".concat(className, " rule-group"),
    isSelected: isSelected,
    groupOperator: (0, _utils.toUpper)(groupOperator)
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    id: "groupOperator".concat(id),
    className: "group-operator"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "operator-label"
  }, operatorLabel), isSelected && !isMenuHidden && !disabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "edit-menu"
  }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
    className: "rule-menu-list",
    menuItems: menuItems,
    position: "top-left",
    id: "".concat(id, "MenuList"),
    ignoreSingleItemLogic: true
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    icon: "ion-android-more-vertical",
    id: "".concat(id, "MenuList")
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "group-elements"
  }, children));
};
RuleGroup.propTypes = {
  /** Html id. */
  id: _propTypes["default"].string.isRequired,
  /** Html class. */
  className: _propTypes["default"].string,
  /** Elements to be displayed inside the group. (eg. Simple rules or other groups) */
  children: _propTypes["default"].node.isRequired,
  /** The logic operator that should be displayed at a block level */
  groupOperator: _propTypes["default"].oneOf(['AND', 'OR', 'IF']).isRequired,
  /** Labels that should be displayed at a block level (eg: AND, OR) */
  labels: _propTypes["default"].shape({}),
  /** Callback to perform when duplicating a rule group */
  onDuplicate: _propTypes["default"].func,
  /** Callback to perform when deleting a rule group */
  onDelete: _propTypes["default"].func,
  /** An array with the position trail of the current rule */
  pathKeys: _propTypes["default"].arrayOf(_propTypes["default"].number),
  /** Flag to indicate weather the duplicate/delete menu should be open */
  isSelected: _propTypes["default"].bool,
  /** Flag to indicate weather the current group should the duplicate group in the list menu */
  isDuplicateDisabled: _propTypes["default"].bool,
  /** Flag to indicate weather the current group should render the list menu */
  isMenuHidden: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
};
RuleGroup.defaultProps = {
  disabled: false,
  className: '',
  isSelected: false,
  labels: {},
  isDuplicateDisabled: false,
  isMenuHidden: false,
  onDuplicate: undefined,
  onDelete: undefined,
  pathKeys: []
};
RuleGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RuleGroup",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Html class.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isSelected": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate weather the duplicate/delete menu should be open",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "labels": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "Labels that should be displayed at a block level (eg: AND, OR)",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "isDuplicateDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate weather the current group should the duplicate group in the list menu",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isMenuHidden": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate weather the current group should render the list menu",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onDuplicate": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Callback to perform when duplicating a rule group",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onDelete": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Callback to perform when deleting a rule group",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "pathKeys": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "An array with the position trail of the current rule",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "number"
        }
      },
      "required": false
    },
    "id": {
      "description": "Html id.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "children": {
      "description": "Elements to be displayed inside the group. (eg. Simple rules or other groups)",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "groupOperator": {
      "description": "The logic operator that should be displayed at a block level",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'AND'",
          "computed": false
        }, {
          "value": "'OR'",
          "computed": false
        }, {
          "value": "'IF'",
          "computed": false
        }]
      },
      "required": true
    }
  }
};
var _default = RuleGroup;
exports["default"] = _default;